import { AxiosInstance } from 'axios';
import IPSetRepositoryInterface, {
  APIDeleteIpFromList,
  APICreateIPSetListInterface,
  APIIPSetListInterface,
  APIBanIpInterface, IpSetIP,
} from '@/services/IPSet/Interfaces';

export default class IPSetRepository implements IPSetRepositoryInterface {
  constructor(
    private axios: AxiosInstance,
  ) {}

  public async getIpSetsList(): Promise<APIIPSetListInterface[]> {
    const res = await this.axios.get('/ipset/sets')

    return res.data
  }

  public async getIpSet(listName: string): Promise<APIIPSetListInterface> {
    const res = await this.axios.get(`/ipset/sets/${listName}`)

    return res.data
  }

  public async searchIps(listName: string, ipSearch: string, resultsFromCache: boolean): Promise<IpSetIP[]> {
    const res = await this.axios.get(`/ipset/sets/${listName}/ips`, {
      params: {
        search: ipSearch,
        cache: resultsFromCache,
      }
    })

    return res.data;
  }

  public async createIpSetList(newIpSetList: APICreateIPSetListInterface): Promise<void> {
    await this.axios.post('/ipset/sets', newIpSetList)
  }

  public async deleteIpSetList(listName: string): Promise<void> {
    await this.axios.delete(`/ipset/sets/${listName}`)
  }

  public async removeIPFromList(payload: APIDeleteIpFromList): Promise<void> {
    await this.axios.delete(`/ipset/sets/${payload.set}/ips/${payload.ip}`)
  }

  public async banIp(payload: APIBanIpInterface): Promise<void> {
    await this.axios.post(`/ipset/sets/${payload.set}/ips`, payload)
  }
}
